import { FC, ReactElement, memo, useState } from 'react';

import { useAppPagination } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import { SiteGroupsSearchingForm, useGetAllSiteGroupsQuery } from '@/modules/SiteGroups';

import { SiteGroupsListView } from './SiteGroupsListView';

export const SiteGroupsListContainer: FC = memo(() => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const {
    data: siteGroupsListData,
    error: siteGroupsListError,
    isLoading: isSiteGroupsListLoading,
    isFetching: isSiteGroupsListFetching,
    isError: isSiteGroupsListError
  } = useGetAllSiteGroupsQuery({ page: currentPage }, search)();

  return (
    <FallbackedLayout
      isLoading={ isSiteGroupsListLoading }
      error={ siteGroupsListError }
      isError={ isSiteGroupsListError }
      data={ siteGroupsListData }
    >
      { (siteGroupsList): ReactElement => (
        <>
          <SiteGroupsSearchingForm search={ search } handleSubmitSearch={ setSearch }/>
          <SiteGroupsListView
            currentPage={ currentPage }
            siteGroupsListItems={ siteGroupsList.items }
            siteGroupsListTotalItems={ siteGroupsList.meta.totalItems }
            siteGroupsListItemsPerPage={ siteGroupsList.meta.itemsPerPage }
            isLoading={ isSiteGroupsListFetching }
            handleChangePage={ handleChangePage }
          />
        </>
      ) }
    </FallbackedLayout>
  );
});
